import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disconnect(): void {
    document.querySelectorAll('.discount-coupon--link-component')[0].style.display = 'none';
  }
}
